import { render } from "./ModalReservationDetail.vue?vue&type=template&id=e85d1f64&scoped=true"
import script from "./ModalReservationDetail.vue?vue&type=script&lang=js"
export * from "./ModalReservationDetail.vue?vue&type=script&lang=js"

import "./ModalReservationDetail.vue?vue&type=style&index=0&id=e85d1f64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e85d1f64"]])

export default __exports__